export default __webpack_public_path__ + "img/placeholder.asset.724606bb.jpg";